import { createApp } from 'vue';
import App from './App.vue';
import router from './router/router';

import './plugins/fontawesome-free/css/all.min.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import './style.css';
import 'vue-toastification/dist/index.css';
import i18n from './locales/i18';
import * as ej2 from '@syncfusion/ej2-base';
import { enableRipple, L10n } from '@syncfusion/ej2-base';

L10n.load({
  'en-grid': {
    'pager': {
      'pagerDropDown': 'Items per page',
      'pagerAllDropDown': 'Items',
      'currentPageInfo': '',
      'totalItemsInfo': 'Showing {1} to {2} of {0} items',
      'totalItemInfo': '{0} items',
    }
  }
});
import lodash from 'lodash';
import { createPinia } from 'pinia';
import { ToastPlugin } from "@syncfusion/ej2-vue-notifications";
import { DropDownListPlugin, MultiSelectPlugin } from '@syncfusion/ej2-vue-dropdowns';
import { GridPlugin, Page, Sort, Filter, Toolbar, ExcelExport, PdfExport } from '@syncfusion/ej2-vue-grids';



ej2.validateLicense('ORg4AjUWIQA/Gnt2VlhhQlJCfV5AQmBIYVp/TGpJfl96cVxMZVVBJAtUQF1hSn5adERjX35cdHNQQGZc');
enableRipple(true);



const app = createApp(App);

app.config.errorHandler = (error, instance, info) => {
  console.log(error);
  console.log(instance);
  console.log(info);
}

app
  .use(createPinia())
  .use(router)
  .use(i18n)
  .use(lodash)
  .use(ToastPlugin)
  .use(DropDownListPlugin)
  .use(MultiSelectPlugin)
  .use(GridPlugin);

app.provide('GridServices', [Page, Sort, Filter, Toolbar, ExcelExport, PdfExport]);

app.mount('#app')
